/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import useStyles from './styles';
import EditButton from '../../common/buttons/EditButton';
import DeleteButton from '../../common/buttons/DeleteButton';
import dateFormat from '../../../utils/dateFormat';


const SimpleList = ({
  data, openDeleteModal,
}) => {
  const history = useHistory();
  const { t } = useTranslation(['translation']);
  const classes = useStyles();
  return (
    <div className={classes.listContainer}>
      {data.map(val => {
        const { dates, status } = val.splits[0];
        const { begin, end } = dates;
        const isActive = status === 'Active' && new Date() <= new Date(end);
        const currentStatus = isActive
          ? t('CAMPAIGN.CAMPAIGN_STATUS.ACTIVE')
          : t('CAMPAIGN.CAMPAIGN_STATUS.FINISHED');
        return (
          <div key={val._id} className={classes.simpleItem}>
            <div className={classes.primaryText}>
              <span className={classes.campaignName}>{val.name}</span>
              <span style={{ color: isActive ? 'green' : 'red' }}>
                {currentStatus}
              </span>
            </div>
            <div className={classes.secondaryText}>
              <div className={classes.datesWrapper}>
                <span className={classes.beginDate}>{dateFormat(begin)}</span>
                <span className={classes.endDate}>{dateFormat(end)}</span>
              </div>
              <div className={classes.btnGroup}>
                <EditButton onClick={() => { history.push(`/campaigns/edit/${val._id}`); }} />
                <DeleteButton onClick={() => { openDeleteModal(val._id, val.name); }} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};


SimpleList.propTypes = {
  data: PropTypes.array.isRequired,
  openDeleteModal: PropTypes.func.isRequired,
};

export default SimpleList;
